import { Notification as NotificationRsuite } from 'rsuite';
import { object } from "prop-types";
import { Language } from "./Language";
import { Constants } from "../configs/Constants";

const language: Language = new Language();


interface INotification {
    success: (title: string, description: string) => void,
    error: (title: string, description: string) => void,
    successObject: (response: any) => void,
    notificationObject: (response: any) => void,
    errorObject: (errors: any) => void
    deleteObject: (errors: any) => void
}

export const Notification: INotification = {
    success: (title: string, description: string) => {
        NotificationRsuite.success({
            title: title,
            description: description,
            placement: 'bottomStart',
            duration: Constants.NOTIFICATION_DURATION,
            bottom: 5,
            top: 5
        });
    },
    error: (title: string, description: any) => {
        NotificationRsuite.error({
            title: title,
            description: description,
            placement: 'bottomStart',
            duration: Constants.NOTIFICATION_DURATION,
            bottom: 5,
            top: 5
        });
    },
    successObject: (response: any) => {
        let description = language.getTranslation('los_datos_se_han_guardado_con_exito');

        if (response.data && response.data.message) {
            description = response.data.message;
        } else if (response.message) {
            description = response.message;
        }

        Notification.success(language.getTranslation('guardado'), description);
    },
    notificationObject: (response: any) => {
        let description = language.getTranslation('los_datos_se_han_guardado_con_exito');

        if (response.data && response.data.message) {
            description = response.data.message;
        } else if (response.message) {
            description = response.message;
        }

        Notification.success(language.getTranslation('mensaje'), description);
    },
    errorObject: (errors: any) => {
        let description = language.getTranslation('ha_ocurrido_un_error_al_guardar');

        if (errors.response && errors.response.data && errors.response.data.message) {
            description = errors.response.data.message;
        } else if (errors.response && errors.response.message) {
            description = errors.response.message;
        } else if (errors.message) {
            description = errors.message;
        }

        Notification.error(language.getTranslation('error'), description);
    },
    deleteObject: (response: any) => {
        let description = language.getTranslation('los_datos_se_han_eliminado_con_exito');

        if (response.data.message) {
            description = response.data.message;
        } else if (response.message) {
            description = response.message;
        }

        Notification.success(language.getTranslation('eliminado'), description);
    }
};
